import contactUsImage from "../../assets/landingPageItems/getInTouch.jpg";
import link from "../../assets/landingPageItems/link.svg";
import { useState } from "react";
export default function ContactUs() {
  const [fileName, setFileName] = useState("No File Chosen");

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setFileName(e.target.files[0].name);
    } else {
      setFileName("No File Chosen");
    }
  };

  return (
    <section
      id="contact"
      className="bg-lightBlue text-white py-8 md:py-12 px-4 max-lg:px-8 md:pl-16 max-w-[2400px] mx-auto"
    >
      <h2 className="text-3xl sm:text-4xl md:text-5xl xl:text-6xl font-audiowide mb-10 text-center ">
        Get In Touch With <span className="text-green-500">Us</span>
      </h2>
      <div className=" mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
        <div>
          <form className="space-y-6 mb-4 ">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block mb-1 font-semibold text-base smd:text-lg">
                  Name
                </label>
                <input
                  type="text"
                  placeholder="Enter Name"
                  className="w-full border-b-2 border-lightGreen bg-transparent placeholder-gray-300 focus:outline-none p-2 text-sm smd:text-base"
                />
              </div>
              <div>
                <label className="block mb-1 font-semibold text-base smd:text-lg">
                  Email
                </label>
                <input
                  type="email"
                  placeholder="Enter Email"
                  className="w-full border-b-2 border-lightGreen bg-transparent placeholder-gray-300 focus:outline-none p-2 text-sm smd:text-base"
                />
              </div>
              <div>
                <label className="block mb-1 font-semibold text-base smd:text-lg">
                  Contact
                </label>
                <input
                  type="text"
                  placeholder="Enter Contact Number"
                  className="w-full border-b-2 border-lightGreen bg-transparent placeholder-gray-300 focus:outline-none p-2 text-sm smd:text-base"
                />
              </div>
              <div>
                <label className="block mb-1 font-semibold text-base smd:text-lg">
                  Company
                </label>
                <input
                  type="text"
                  placeholder="Enter Company Name"
                  className="w-full border-b-2 border-lightGreen bg-transparent placeholder-gray-300 focus:outline-none p-2 text-sm smd:text-base"
                />
              </div>
            </div>

            <div>
              <label className="block mb-1 font-semibold text-base smd:text-lg">
                Describe Your Requirements
              </label>
              <textarea
                rows={5}
                placeholder="Describe Your Requirements"
                className="w-full border-2 border-lightGreen bg-transparent placeholder-gray-300 focus:outline-none p-3 text-sm smd:text-base resize-none"
              ></textarea>
            </div>

            <div className="border-b-2 max-md:pb-4 border-lightGreen">
              <label className="block mb-2 text-base smd:text-lg font-semibold">
                Attach Document{" "}
                <span className="text-gray-300 font-normal text-sm smd:text-base">
                  (Max 5MB, Only text, pdf, .zip or rar)
                </span>
              </label>
              <div className="relative inline-flex items-center">
                <label className="flex items-center cursor-pointer bg-transparent  px-4 py-2 text-green-500 ">
                  <img
                    src={link}
                    alt="Ledgerate Logo"
                    className="h-5 max-md:mx-auto px-2 items-center"
                  />
                  <span className="text-white">Choose File</span>
                  <input
                    type="file"
                    className="absolute left-0 top-0 w-full h-full opacity-0 cursor-pointer"
                    onChange={handleFileChange}
                  />
                </label>
                <span className="ml-4 text-sm text-gray-400">{fileName}</span>
              </div>
            </div>

            <button
              type="submit"
              className="bg-lightGreen text-lightBlue px-6 py-2 rounded hover:bg-green-600 transition"
            >
              Submit
            </button>
          </form>
        </div>
        <div className="hidden lg:flex justify-center">
          <img
            draggable="false"
            src={contactUsImage}
            alt="Support representative"
            className="rounded-tl-xl  w-full max-w-7xl  object-cover -mr-8"
          />
        </div>
      </div>
    </section>
  );
}
